import { Badge } from '@/components/ui/badge';
import {
  FinanceBulkImportEntityType,
  FinanceBulkImportRowStatus,
} from '@/graphql/generatedTypes';
import { cn } from '@/lib/utils';

const STATUS_CLASS: Record<FinanceBulkImportRowStatus, string> = {
  [FinanceBulkImportRowStatus.Error]:
    'tw:bg-destructive/10 tw:text-destructive',
  [FinanceBulkImportRowStatus.Conflict]: 'tw:bg-amber-100 tw:text-amber-800',
  [FinanceBulkImportRowStatus.Changed]: 'tw:bg-blue-100 tw:text-blue-800',
  [FinanceBulkImportRowStatus.Applied]: 'tw:bg-green-100 tw:text-green-800',
  [FinanceBulkImportRowStatus.Unchanged]:
    'tw:bg-muted tw:text-muted-foreground',
};

export function StatusBadge({
  status,
}: {
  status: FinanceBulkImportRowStatus | null | undefined;
}) {
  if (!status) {
    return null;
  }
  return <Badge className={cn(STATUS_CLASS[status])}>{status}</Badge>;
}

export function EntityTypeBadge({
  entityType,
}: {
  entityType: FinanceBulkImportEntityType | null | undefined;
}) {
  if (!entityType) {
    return <span className="tw:text-muted-foreground">–</span>;
  }
  return (
    <Badge variant="outline">
      {entityType === FinanceBulkImportEntityType.Store
        ? 'Store'
        : 'Invoice collection'}
    </Badge>
  );
}
